import { render, staticRenderFns } from "./RolesDropdown.vue?vue&type=template&id=c5c180aa&scoped=true&"
import script from "./RolesDropdown.vue?vue&type=script&lang=js&"
export * from "./RolesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RolesDropdown.vue?vue&type=style&index=0&id=c5c180aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c180aa",
  null
  
)

export default component.exports